import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import GeoCoding from 'components/GeoCoding/GeoCoding';
import { cmmUtils } from 'utils/cmmUtils.js';
import { useRecoilState } from 'recoil';
import { authAtom } from '../_state';
import { authUtils } from '../utils/authUtils';

let columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: `type`, label: '구분', minWidth: 140, align: 'center' },
  { id: 'uploadFileName', label: '변환 파일명', minWidth: 100, align: 'left' },
  { id: 'createdAt', label: '변환일시', minWidth: 100, align: 'center' },
  { id: 'successCount', label: '성공 건수', minWidth: 100, align: 'center', format: (value) => value.toLocaleString('en-US') },
  { id: 'errorCount', label: '실패 건수', minWidth: 180, align: 'center', format: (value) => value.toLocaleString('en-US') },
  { id: 'download', label: '다운로드', minWidth: 180, align: 'center' }
];

export default function ActiveCodeMng() {
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);
  const [dueDate, setDueDate] = useState('');
  const [isDidas, setIsDidas] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [openGeoCoding, setOpenGeoCoding] = useState(false);
  const [auth, setAuth] = useRecoilState(authAtom);

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const getDataList = async (e) => {
    let params = {
      offset,
      page,
      limit: offset
    };

    await axios
      .get(`/api/geo-code`, { params })
      .then((response) => {
        if (response.data) {
          const result = response.data;
          setPageCnt(Math.ceil(result.count / offset));
          setRows(result.rows);
          if (e?.target) {
            setPage(1);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const downloadShp = async (row) => {
    let data = {};
    data.type = 'geo';
    data.features = row.successJson;
    data.fileName = `${row.uploadFileName.substring(0, row.uploadFileName.lastIndexOf('.'))}.zip`;
    await axios
      .post(`/api/geo-code/download`, data, { responseType: 'blob' })
      .then(async (response) => {
        let blob = new Blob([response.data], {
          type: <response className="headers"></response>
        });
        let name = getFileName(decodeURIComponent(response.headers['content-disposition']));
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.target = '_self';
          if (name) link.download = name;
          link.click();
          window.URL.revokeObjectURL(link);
        }
      })
      .catch((error) => {
        alert('다운 실패!');
      });
  };

  const getFileName = (contentDisposition) => {
    let fileName = contentDisposition
      .split(';')
      .filter((el) => el.indexOf('filename') > -1)
      .map((ele) => ele.replace(/"/g, '').split('=')[1]);
    return fileName[0];
  };

  const downloadErrorExcel = async (row) => {
    cmmUtils.excelDownload(row.errorJson, `${row.uploadFileName.substring(0, row.uploadFileName.lastIndexOf('.'))}_실패`, null, null);
  };

  const handleClickOpenGeoCoding = () => {
    setOpenGeoCoding(true);
  };

  const handleCloseGeoCoding = () => {
    setOpenGeoCoding(false);
  };

  useEffect(async () => {
    if (!isDidas) {
      await axios.get('/api/active/is-payment').then(async (result) => {
        setIsPayment(result.data.isPayment);
        setDueDate(result.data.dueDate);
      });
    }
    await getDataList(page);
  }, [isDidas]);

  useEffect(async () => {
    setIsDidas(auth?.isDidas);
  }, [auth]);

  useEffect(async () => {
    await getDataList(page);
  }, [page]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        지오코딩
      </Typography>
      {!authUtils.useIsAdmin() && !isDidas && !isPayment && (
        <>
          <Typography variant="h5" display="inline" gutterBottom sx={{ ml: 1, color: 'red' }}>
            {`사용 중인 활성화 코드가 없습니다.`}
          </Typography>
          <Typography variant="h5" display="inline" gutterBottom sx={{ ml: 1, color: 'red' }}>
            {`지오 코딩은 활성화 코드 사용 기간 동안에 사용 가능합니다.`}
          </Typography>
        </>
      )}
      {!authUtils.useIsAdmin() && !isDidas && isPayment && (
        <>
          <Typography variant="h5" display="inline" gutterBottom sx={{ ml: 1 }}>
            {`활성화 코드 유효기간 : ~ ${dueDate}`}
          </Typography>
        </>
      )}
      <Grid container spacing={2}>
        <Grid item sx={{ width: '100%' }}>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" onClick={handleClickOpenGeoCoding} sx={{ ml: 1 }} disabled={!isPayment && !isDidas}>
              지오코딩
            </Button>
            <Button variant="contained" onClick={handleClickOpenGeoCoding} disabled={true} sx={{ ml: 1 }}>
              리버스 지오코딩
            </Button>
          </Box>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={'center'} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id}>
                    {columns.map((col, colIdx) => {
                      const value = row[col.id];
                      if (col.id === 'download') {
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {row.successJson && row.successJson.length > 0 && (
                              <Button variant="contained" color="primary" size="small" onClick={() => downloadShp(row)} sx={{ ml: 1 }}>
                                SHP 다운
                              </Button>
                            )}
                            {row.errorJson && row.errorJson.length > 0 && (
                              <Button variant="contained" color="error" size="small" onClick={() => downloadErrorExcel(row)} sx={{ ml: 1 }}>
                                실패 엑셀 다운
                              </Button>
                            )}
                          </TableCell>
                        );
                      }
                      return (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                          {col.format && typeof value === 'number' ? col.format(value) : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
      </Grid>
      <GeoCoding open={openGeoCoding} handleClose={handleCloseGeoCoding} getDataList={getDataList} />
    </Paper>
  );
}
